"use strict";
/*
 * Created on 25. 2. 2019
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var big_decimal_1 = require("@logio/big-decimal");

var immutable_1 = require("immutable");

var utils_1 = require("../../core/utils");

var SparseMatrix_1 = require("../../core/utils/SparseMatrix");

var CannibalizationItem_1 = require("./CannibalizationItem");

var WindowPromoEffectBase_1 = require("./WindowPromoEffectBase");
/**
 * @author Stepan Mik
 */


var WindowPromoEffect =
/*#__PURE__*/
function (_WindowPromoEffectBas) {
  _inherits(WindowPromoEffect, _WindowPromoEffectBas);

  function WindowPromoEffect(id, windowId, promotionId, products, userTotalAmounts, positiveIncrementAmounts, postPromoAmounts, postPromoDates, baselineProducts, baselineAmounts, cannibalization, dailyTotals, historic) {
    var _this;

    _classCallCheck(this, WindowPromoEffect);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowPromoEffect).call(this, id, windowId, promotionId, products, userTotalAmounts, positiveIncrementAmounts, postPromoAmounts, postPromoDates, baselineProducts, baselineAmounts, cannibalization, dailyTotals, historic));
    _this.cannibalizationMatrix = _this.cannibalization.reduce(function (acc, ci) {
      acc.set(ci.cannibal, ci.victim, ci.amount);
      return acc;
    }, SparseMatrix_1.SparseMatrix.stringStringMatrix(big_decimal_1.BigDecimal.ZERO));
    _this.userTotals = immutable_1.Map(immutable_1.List(_this.products).zip(immutable_1.List(_this.userTotalAmounts)));
    _this.positiveIncrements = immutable_1.Map(immutable_1.List(_this.products).zip(immutable_1.List(_this.positiveIncrementAmounts)));
    _this.postPromo = immutable_1.Map(immutable_1.List(_this.products).zip(immutable_1.List(_this.postPromoAmounts)));
    _this.postPromoEnds = immutable_1.Map(immutable_1.List(_this.products).zip(immutable_1.List(_this.postPromoDates)));
    _this.baseline = immutable_1.Map(immutable_1.List(_this.baselineProducts).zip(immutable_1.List(_this.baselineAmounts)));
    return _this;
  }

  _createClass(WindowPromoEffect, null, [{
    key: "indexOf",
    value: function indexOf(arr, val) {
      var low = 0;
      var high = arr.length - 1;

      while (low <= high) {
        // tslint:disable-next-line:no-bitwise
        var mid = low + high >>> 1;
        var cmp = val.localeCompare(arr[mid]);

        if (cmp > 0) {
          low = mid + 1;
        } else if (cmp < 0) {
          high = mid - 1;
        } else {
          return mid; // key found
        }
      }

      return -(low + 1); // key not found.
    }
  }, {
    key: "merge",
    value: function merge(keys, vals, key, val, merger, cloner) {
      var idx = WindowPromoEffect.indexOf(keys, key);

      if (idx >= 0) {
        vals[idx] = merger(vals[idx], val);
      } else {
        idx = -idx - 1;
        keys.splice(idx, 0, key);
        vals.splice(idx, 0, cloner ? cloner(val) : val);
      }
    }
  }, {
    key: "mergeArr",
    value: function mergeArr(keys1, vals1, keys2, vals2, merger, cloner) {
      for (var i = 0; i < keys2.length; i++) {
        WindowPromoEffect.merge(keys1, vals1, keys2[i], vals2[i], merger, cloner);
      }
    }
  }, {
    key: "fromSites",
    value: function fromSites(windowId, promotionId, historic, wpes) {
      var products = [];
      var userTotalAmounts = [];
      var positiveIncrementAmounts = [];
      var postPromoAmounts = [];
      var postPromoDates = [];
      var baselineProducts = [];
      var baselineAmounts = [];
      var cannibalization = [];
      var dailyTotals = [];
      var matrix = SparseMatrix_1.SparseMatrix.stringStringMatrix(big_decimal_1.BigDecimal.ZERO);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = wpes.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var wpe = _step.value;

          if (windowId !== wpe.windowId) {
            utils_1.Utils.fail('Window IDs must match');
          }

          if (promotionId !== wpe.promotionId) {
            utils_1.Utils.fail('Window promo IDs must match');
          }

          if (historic !== wpe.historic) {
            utils_1.Utils.fail('Window historic status must match');
          }

          WindowPromoEffect.mergeArr([].concat(products), dailyTotals, wpe.products, wpe.dailyTotals, function (a, b) {
            a.length !== b.length ? utils_1.Utils.fail('SNH') : immutable_1.Range(0, a.length).forEach(function (i) {
              return a[i] = a[i].add(b[i]);
            });
            return a;
          }, function (a) {
            return _toConsumableArray(a);
          });
          WindowPromoEffect.mergeArr([].concat(products), userTotalAmounts, wpe.products, wpe.userTotalAmounts, function (a, b) {
            return a.add(b);
          });
          WindowPromoEffect.mergeArr([].concat(products), postPromoAmounts, wpe.products, wpe.postPromoAmounts, function (a, b) {
            return a.add(b);
          });
          WindowPromoEffect.mergeArr([].concat(products), postPromoDates, wpe.products, wpe.postPromoDates, function (a, b) {
            return a.isBefore(b) ? b : a;
          });
          WindowPromoEffect.mergeArr(products, positiveIncrementAmounts, wpe.products, wpe.positiveIncrementAmounts, function (a, b) {
            return a.add(b);
          });
          WindowPromoEffect.mergeArr(baselineProducts, baselineAmounts, wpe.baselineProducts, wpe.baselineAmounts, function (a, b) {
            return a.add(b);
          });
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            var _loop = function _loop() {
              var ci = _step3.value;
              matrix.update(ci.cannibal, ci.victim, function (a) {
                return a.add(ci.amount);
              });
            };

            for (var _iterator3 = wpe.cannibalization[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              _loop();
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = matrix[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _step2$value = _slicedToArray(_step2.value, 3),
              c = _step2$value[0],
              v = _step2$value[1],
              a = _step2$value[2];

          cannibalization.push(new CannibalizationItem_1.CannibalizationItem(c, v, a));
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return new WindowPromoEffect(utils_1.Utils.VOID_ID, windowId, promotionId, products, userTotalAmounts, positiveIncrementAmounts, postPromoAmounts, postPromoDates, baselineProducts, baselineAmounts, cannibalization, dailyTotals, historic);
    }
  }]);

  return WindowPromoEffect;
}(WindowPromoEffectBase_1.WindowPromoEffectBase);

exports.WindowPromoEffect = WindowPromoEffect;
WindowPromoEffect.EMPTY = new WindowPromoEffect(utils_1.Utils.VOID_ID, utils_1.Utils.VOID_ID, utils_1.Utils.VOID_ID, [], [], [], [], [], [], [], [], [], false);